export default "__VITE_ASSET__BQCVPhwW__"